__turbopack_context__.v({
  "col1": "PlasmicPricingWhySection-module__1eu2IG__col1",
  "header": "PlasmicPricingWhySection-module__1eu2IG__header",
  "img__jXaSp": "PlasmicPricingWhySection-module__1eu2IG__img__jXaSp",
  "img__mbYrr": "PlasmicPricingWhySection-module__1eu2IG__img__mbYrr",
  "img__pnfVq": "PlasmicPricingWhySection-module__1eu2IG__img__pnfVq",
  "img__y5Rq": "PlasmicPricingWhySection-module__1eu2IG__img__y5Rq",
  "items": "PlasmicPricingWhySection-module__1eu2IG__items",
  "row": "PlasmicPricingWhySection-module__1eu2IG__row",
  "row2": "PlasmicPricingWhySection-module__1eu2IG__row2",
  "sectionHeader": "PlasmicPricingWhySection-module__1eu2IG__sectionHeader",
  "textWithIcon__n1CV": "PlasmicPricingWhySection-module__1eu2IG__textWithIcon__n1CV",
  "textWithIcon__tmqtr": "PlasmicPricingWhySection-module__1eu2IG__textWithIcon__tmqtr",
  "textWithIcon__xkI0R": "PlasmicPricingWhySection-module__1eu2IG__textWithIcon__xkI0R",
  "textWithIcon__xl7H0": "PlasmicPricingWhySection-module__1eu2IG__textWithIcon__xl7H0",
  "whySection": "PlasmicPricingWhySection-module__1eu2IG__whySection",
  "wrapper": "PlasmicPricingWhySection-module__1eu2IG__wrapper",
});
